import React from 'react';
import Modal from '@/components/modal/Modal';
import { Col, Row } from '@/lib/utils';
import { MediumText, RegularText } from '@/lib/Text';

type Props = {
    onClose: () => void;
    onConfirm: () => void;
    title?: string;
    description?: React.ReactNode;
    /** 설명 아래 작은 안내 한 줄. 기본은 예외 수업료 재계산 안내(D9). */
    note?: React.ReactNode;
    whiteViewHeight?: number;
};

const ModalChangeDetailSettlementMode = ({
    onClose,
    onConfirm,
    title = '정산 모드를 변경할까요?',
    description = '정산 설정은 하나의 모드로만 할 수 있어요. ',
    // 예외 수업료는 정산 방식마다 해석이 달라(배수가 곱하는 대상, 기본 정산의 재등록·노쇼 칸) 바꾸면 다시 계산된다.
    note = '예외 수업료도 바뀐 방식으로 다시 계산돼요.',
    whiteViewHeight = 295,
}: Props) => {
    return (
        <Modal
            onClose={onClose}
            whiteViewWidth={495}
            whiteViewHeight={whiteViewHeight}
            borderRadius={20}
            isCloseButton={false}
            isWhiteOverFlowScroll={false}
        >
            <div className="px-[33px] pt-[17px] pb-[21px]">
                <MediumText fontSize={22} lineHeight={38} color="#3D4244" letterSpacing={-0.5}>
                    {title}
                </MediumText>
                <Col className="flex flex-col mt-[28px]">
                    <RegularText fontSize={22} lineHeight={35} color="#3D4244">
                        {description}
                    </RegularText>
                    {note && (
                        <RegularText fontSize={16} lineHeight={24} color="#6B7280" className="mt-[8px]">
                            {note}
                        </RegularText>
                    )}
                </Col>
                <Row className={`gap-[12px] justify-end ${note ? 'mt-[68px]' : 'mt-[100px]'}`}>
                    <div
                        className="w-[110px] h-[41px] bg-[#F4F5F7] rounded-[12px] flex items-center justify-center cursor-pointer"
                        onClick={onClose}
                    >
                        <RegularText fontSize={16} color="#3D4244">
                            취소
                        </RegularText>
                    </div>
                    <div
                        className="w-[110px] h-[41px] bg-[#3D73DD] rounded-[12px] flex items-center justify-center cursor-pointer"
                        onClick={() => {
                            onClose();
                            onConfirm();
                        }}
                    >
                        <RegularText fontSize={16} color="#FFFFFF">
                            변경하기
                        </RegularText>
                    </div>
                </Row>
            </div>
        </Modal>
    );
};

export default ModalChangeDetailSettlementMode;
